// utils/videoEvents.js
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../firebase';

/**
 * Logs a video deletion event to Firestore
 * @param {string} videoId - The ID of the deleted video
 * @param {Object} videoData - Optional data about the deleted video
 * @returns {Promise<void>}
 */
export const logVideoDeletion = async (videoId, videoData = {}) => {
  console.log('Attempting to log video deletion event...', { videoId, videoData });
  
  try {
    const user = auth.currentUser;
    if (!user) {
      console.warn('Cannot log video deletion: No authenticated user');
      return;
    }

    const eventData = {
      eventType: 'deletion',
      videoId: videoId,
      userId: user.uid,
      timestamp: serverTimestamp(),
      videoTitle: videoData.title || '',
      videoDuration: videoData.duration || '',
      videoCreatedAt: videoData.createdAt || null
    };

    console.log('Preparing to add video_events document with data:', eventData);
    
    const eventsRef = collection(db, 'video_events');
    const docRef = await addDoc(eventsRef, eventData);
    
    console.log(`Successfully logged deletion event for video ${videoId}`, { eventDocId: docRef.id });
    return docRef.id;
  } catch (error) {
    console.error('Error logging video deletion:', error);
    // Check for specific permission errors
    if (error.code === 'permission-denied') {
      console.error('Permission denied. Check Firestore rules for video_events collection');
    }
    // Don't throw - we don't want deletion logging failures to affect the user experience
    return null;
  }
};